import { UploadInvoiceActionContext } from "./UploadInvoiceActionContext";
import usePrepareUploadInvoice from "./usePrepareUploadInvoice";
import {createRef, useContext} from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import JSONSchemaForm from "@rjsf/core";
import UploadInvoiceOrderForm from "@beeldit/ecommerce/orders/components/UploadInviceOrderForm";
import useUploadInvoice from "@beeldit/ecommerce/orders/actions/upload-invoice/useUploadInvoice";

function useUploadInvoiceAction(onSuccess: any): any {
  const prepareUploadInvoice = usePrepareUploadInvoice();
  const prepareUploadInvoiceFunction = (id: any) => prepareUploadInvoice(id);

  const onSuccessUpload = () => {
    setShowModal(false);
    showSuccessMessage("successfull_action");
    onSuccess();
  };

  const uploadInvoice = useUploadInvoice();

  const uploadInvoiceFunction = () => uploadInvoice(onSuccessUpload);

  const contextInstance = useContext(UploadInvoiceActionContext);
  const { setShowModal, element } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "upload_invoice",
    onSubmit: () => uploadInvoiceFunction(),
  };

  const formRef = createRef<JSONSchemaForm>();


  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      uploadInvoiceFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: UploadInvoiceActionContext,
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <UploadInvoiceOrderForm formConfig={formConfig}/>
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareUploadInvoiceFunction,
    actionTemplate,
  };
}

export default useUploadInvoiceAction;
